module.exports = __webpack_public_path__ + "img/浙江大学logo.baca521c.png";